function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import _ from "lodash";
import { defineComponent, onMounted, ref, computed, watch, getCurrentInstance } from "vue";
import SearchBar from "@/components/SearchV3/index.vue";
import TransferSetting from "./transfer-setting.vue";
import { planList, getPlanList } from "../index";
import { PermissionKey, GrantTypeLabel, statusOptions } from "@/common/permission";
import { messageAdvList } from "@/api/message/message";
var defaultQuery = {
    adv_ids: [],
    grant_type: undefined,
    permissions: [],
    plan_ids: [],
    country: [],
    custom: undefined,
    status: undefined,
    page: 1,
    page_size: 15
};
export default defineComponent({
    components: {
        SearchBar: SearchBar,
        TransferSetting: TransferSetting
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleResetSearch = function handleResetSearch() {
            query.value = _objectSpread({}, defaultQuery);
            needAllQuery.value = _objectSpread({}, defaultQuery);
            handleSearch(true);
        };
        var load = function load() {
            if (advertisersTotal && query.value.page * query.value.page_size < advertisersTotal.value) {
                query.value.page++;
                handleSearch(false);
            }
        };
        var handleSave = function handleSave() {
            var _$ref;
            emit("add", (_$ref = transferSettingRef.value) === null || _$ref === void 0 ? void 0 : _$ref.selectData);
            emit("update:visible", false);
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var countryList = ref([]);
        var transferSettingRef = ref();
        var query = ref(_objectSpread({}, defaultQuery));
        // 全部添加的筛选项;由于query会根据选项变化，但是数据只有在点击搜索后才会更新数据
        var needAllQuery = ref(_objectSpread({}, defaultQuery));
        var advertisersList = ref([]);
        var advertisersTotal = ref(0);
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var formItemList = computed(function() {
            return [
                {
                    prop: "adv_ids",
                    type: "business",
                    subtype: "advertiser-selector",
                    params: {
                        multiple: true,
                        filterable: true,
                        collapseTags: true,
                        style: "width: 220px;",
                        class: "search-filter-select"
                    }
                },
                {
                    type: "select",
                    prop: "grant_type",
                    params: {
                        placeholder: "\u8BA2\u9605\u7C7B\u578B",
                        multiple: true,
                        clearable: true,
                        filterable: true,
                        collapseTags: true,
                        options: _.map(GrantTypeLabel, function(v, k) {
                            return {
                                label: v,
                                value: Number(k)
                            };
                        })
                    }
                },
                {
                    type: "select",
                    prop: "permissions",
                    params: {
                        clearable: true,
                        multiple: true,
                        filterable: true,
                        "collapse-tags": true,
                        placeholder: "\u6388\u6743\u529F\u80FD",
                        options: [
                            {
                                label: "\u53EF\u73A9\u6362\u80A4\u7F16\u8F91",
                                value: PermissionKey.gm
                            },
                            {
                                label: "\u53EF\u73A9\u81EA\u7531\u7F16\u8F91",
                                value: PermissionKey.ps
                            },
                            {
                                label: "\u6388\u6743\u89C6\u9891\u666E\u901A\u5236\u4F5C",
                                value: PermissionKey.ve
                            },
                            {
                                label: "\u6388\u6743\u5F55\u5C4F\u5DE5\u5177",
                                value: PermissionKey.vrec
                            }, 
                        ]
                    }
                },
                {
                    type: "select",
                    prop: "plan_ids",
                    params: {
                        placeholder: "\u5957\u9910\u540D\u79F0",
                        multiple: true,
                        filterable: true,
                        "collapse-tags": true,
                        clearable: true,
                        options: planList.value
                    }
                },
                {
                    type: "select",
                    prop: "status",
                    params: {
                        placeholder: "\u5957\u9910\u72B6\u6001",
                        multiple: true,
                        clearable: true,
                        filterable: true,
                        collapseTags: true,
                        options: _.map(statusOptions, function(v, k) {
                            return {
                                label: v,
                                value: k
                            };
                        })
                    }
                },
                {
                    type: "select",
                    prop: "custom",
                    params: {
                        placeholder: "\u662F\u5426\u5B9A\u5236",
                        clearable: true,
                        options: [
                            {
                                label: "\u662F",
                                value: 1
                            },
                            {
                                label: "\u5426",
                                value: 2
                            }, 
                        ]
                    }
                },
                {
                    type: "select",
                    prop: "country",
                    params: {
                        filterable: true,
                        clearable: true,
                        multiple: true,
                        collapseTags: true,
                        options: countryList.value,
                        placeholder: "\u8BF7\u9009\u62E9\u56FD\u5BB6"
                    }
                }, 
            ];
        });
        watch(function() {
            return props.visible;
        }, function(val) {
            if (!val) {
                handleResetSearch();
                advertisersList.value = [];
                advertisersTotal.value = 0;
            }
        });
        function getCountryList() {
            return _getCountryList.apply(this, arguments);
        }
        function _getCountryList() {
            _getCountryList = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            root.$store.dispatch("config/getCountryList").then(function(data) {
                                countryList.value = data;
                            });
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getCountryList.apply(this, arguments);
        }
        function handleSearch(clear) {
            return _handleSearch.apply(this, arguments);
        }
        function _handleSearch() {
            _handleSearch = _asyncToGenerator(regeneratorRuntime.mark(function _callee(clear) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            if (clear) {
                                query.value.page = 1;
                                advertisersList.value = [];
                                advertisersTotal.value = 0;
                            }
                            _ctx.next = 4;
                            return messageAdvList(query.value);
                        case 4:
                            res = _ctx.sent;
                            if (!(res.status !== 200)) {
                                _ctx.next = 8;
                                break;
                            }
                            root.$message.error("\u51FA\u9519\u4E86");
                            return _ctx.abrupt("return");
                        case 8:
                            advertisersList.value = advertisersList.value.concat(_.get(res, "data.data.list") || []);
                            advertisersTotal.value = _.get(res, "data.data.total") || 0;
                            needAllQuery.value = _objectSpread({}, query.value);
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return _handleSearch.apply(this, arguments);
        }
        function handleAdd() {
            return _handleAdd.apply(this, arguments);
        }
        function _handleAdd() {
            _handleAdd = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var _$ref, res, list;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return messageAdvList(_objectSpreadProps(_objectSpread({}, needAllQuery.value), {
                                page: 1,
                                need_all: 1
                            }));
                        case 4:
                            res = _ctx.sent;
                            if (!(res.status !== 200)) {
                                _ctx.next = 8;
                                break;
                            }
                            root.$message.error("\u51FA\u9519\u4E86");
                            return _ctx.abrupt("return");
                        case 8:
                            list = _.get(res, "data.data.list") || [];
                            (_$ref = transferSettingRef.value) === null || _$ref === void 0 ? void 0 : _$ref.handleAllAdd(list);
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return _handleAdd.apply(this, arguments);
        }
        onMounted(function() {
            getPlanList();
            getCountryList();
        });
        return {
            transferSettingRef: transferSettingRef,
            dialogVisible: dialogVisible,
            query: query,
            formItemList: formItemList,
            advertisersList: advertisersList,
            advertisersTotal: advertisersTotal,
            handleResetSearch: handleResetSearch,
            handleSearch: handleSearch,
            handleSave: handleSave,
            load: load,
            handleAdd: handleAdd
        };
    }
});
